// src/components/AuthModal.tsx
import {
	Modal,
	Button,
	Text,
	Stack,
	Group,
	Paper,
	ThemeIcon,
	rem,
} from '@mantine/core';
import {
	IconBrandGoogle,
	IconCloud,
	IconDeviceMobile,
	IconLock,
	Icon,
} from '@tabler/icons-react';

interface AuthModalProps {
	opened: boolean;
	onClose: () => void;
	onSignIn: () => void;
	loading: boolean;
}

interface Feature {
	icon: Icon;
	title: string;
	description: string;
}

function AuthModal({ opened, onClose, onSignIn, loading }: AuthModalProps) {
	const features: Feature[] = [
		{
			icon: IconCloud,
			title: 'Secure Cloud Storage',
			description:
				'Your data is securely stored and backed up in the cloud',
		},
		{
			icon: IconDeviceMobile,
			title: 'Access Anywhere',
			description: 'Access your bills from any device, anytime',
		},
		{
			icon: IconLock,
			title: 'Private & Secure',
			description: 'Your data is encrypted and only accessible to you',
		},
	];

	return (
		<Modal
			opened={opened}
			onClose={onClose}
			title='Sign in for Cloud Backup'
			centered
			size='md'
		>
			<Stack gap='xl'>
				<Text size='sm' c='dimmed'>
					Sign in with your Google account to enable cloud backup and
					sync your bills across devices.
				</Text>

				<Button
					leftSection={<IconBrandGoogle size={16} />}
					onClick={onSignIn}
					loading={loading}
					fullWidth
					size='md'
				>
					Continue with Google
				</Button>

				<Stack gap='md'>
					{features.map((feature) => (
						<Group key={feature.title} wrap='nowrap'>
							<ThemeIcon
								size={40}
								radius='md'
								variant='light'
								color='blue'
							>
								<feature.icon
									style={{ width: rem(20), height: rem(20) }}
									stroke={1.5}
								/>
							</ThemeIcon>
							<div>
								<Text size='sm' fw={500}>
									{feature.title}
								</Text>
								<Text size='xs' c='dimmed'>
									{feature.description}
								</Text>
							</div>
						</Group>
					))}
				</Stack>

				<Paper withBorder p='sm' radius='md'>
					<Text size='xs' c='dimmed'>
						By signing in, you agree to our Terms of Service and
						Privacy Policy. We never post anything without your
						permission.
					</Text>
				</Paper>
			</Stack>
		</Modal>
	);
}

export default AuthModal;
